export const environment = {
    URL: 'https://back.libracol.credienlinea.co',
    USER: 'libracol',
    PASS: 'pvbY1wb91avhQsZ',
    ENTERPRISE: 'Libracol',
    SINGLEROUTE: true
  };
